export const SUPPLIER_LABELS = {
  training: "Training providers",
  recruitment: "Recruitment & staffing",
  software: "Care software & systems",
  consultancy: "Consultancy",
  insurance: "Business insurance",
  clinical_systems: "GP & hospital clinical systems",
  medical_devices: "Medical devices & equipment",
  medical_indemnity: "Medical indemnity",
  pharmacy: "Pharmacy & medicines supply",
  other: "Other",
};

export const supplierLabel = (id) => SUPPLIER_LABELS[id] || id;
export const supplierLabels = (sp) => (sp.categories?.length ? sp.categories : [sp.category]).map(supplierLabel).join(", ");
